if (!customElements.get("museum-of-smoothies")) {
  class MuseumOfSmoothies extends HTMLElement {
    constructor() {
      super();
      this.mute = false;
      this.totalHalls = 0;
      this.currentHall = 0;
      this.cues = [];
      this.triggerTime = 5;
      this.playing = false;
    }

    connectedCallback() {
      setTimeout(() => {
        this.exhibitAudio = this.querySelector("#exhibit-audio");
        this.exhibitVid = this.querySelector("#exhibit-vid");
        this.caption = this.querySelector("#caption");
        this.spillButton = this.querySelector("#spill");
        this.audioControl = this.querySelector("#listen");
        this.beginButton = this.querySelector("#begin-button");
        this.foundationLogo = this.querySelector("#foundation-logo");
        this.slider = this.querySelector("[data-swiper]");
        this.totalHalls = this.querySelectorAll(".exhibit").length;
        this.setListeners();
      });
    }

    setListeners() {
      const el = this;

      window.addEventListener("blur", () => {
        if (this.playing) {
          this.exhibitAudio.pause();
          this.exhibitVid.pause();
        }
      });

      window.addEventListener("focus", () => {
        if (this.playing) {
          this.exhibitAudio.play();
          this.exhibitVid.play();
        }
      });

      this.slider.swiper.on("slideChangeTransitionEnd", function () {
        el.setNewHall(this.activeIndex);
      });

      this.slider.swiper.on("slideChangeTransitionStart", function () {
        el.removeOldHall(this.activeIndex);
      });

      this.spillButton.addEventListener("click", () => {
        console.log("pour");
        this.exhibitVid.play(0);
      });

      this.audioControl.addEventListener("click", () => {
        this.mute = !this.mute;
        this.exhibitAudio.muted = this.mute;
      });

      this.captions = this.exhibitAudio.addTextTrack("metadata");
      this.setCaptions(0);
      this.captions.oncuechange = function () {
        const cue = this.activeCues[0];
        if (cue) {
          console.log(cue.text);
          el.caption.innerHTML = cue.text;
        }
      };

      this.exhibitAudio.addEventListener("ended", this.audioEnded.bind(this));

      this.querySelectorAll("[data-init-show]").forEach((initButton) =>
        initButton.addEventListener("click", this.showBegin.bind(this))
      );
    }

    //////////////// START AUDIO CUES /////////////////
    audioEnded() {
      if (this.currentHall !== this.totalHalls) {
        this.currentHall = this.currentHall + 1;
        this.slider.dispatchEvent(new CustomEvent('go-to-slide', {bubbles: true, detail: {index: this.currentHall}}));
      } else {
        alert("showEnds, audio ended, this.currentHall: ", this.currentHall, "this.totalHalls: ", this.totalHalls)
        showEnds();
      }
    }

    clearCues() {
      for (let j = this.captions.cues.length - 1; j > -1; j--) {
        const cue = this.captions.cues[j];
        this.captions.removeCue(cue);
      }
    }

    setCaptions(index) {
      switch (index) {
        case 0:
          this.captions.addCue(new VTTCue(0.1, 4, "The Museum of Smoothies"));
          this.captions.addCue(
            new VTTCue(4, 6, "The smoothie is a magical drink,")
          );
          this.captions.addCue(new VTTCue(6, 7, "that has permeated"));
          this.captions.addCue(
            new VTTCue(7, 9, "ALL aspects of human culture")
          );
          this.captions.addCue(new VTTCue(9, 11, "and beyond."));
          this.captions.addCue(new VTTCue(11, 12, "Explore the history"));
          this.captions.addCue(new VTTCue(12, 13, "of the smoothie"));
          this.captions.addCue(new VTTCue(13, 14.5, "and its profound effect"));
          this.captions.addCue(new VTTCue(14.5, 16, "on human kind."));
          this.captions.addCue(new VTTCue(16, 18, "Let’s begin the tour."));
          break;
        case 1:
          this.captions.addCue(new VTTCue(2, 3, "4 million BC"));
          this.captions.addCue(new VTTCue(5, 7, "Early Man Sipped:"));
          this.captions.addCue(new VTTCue(7, 9, "The prehistoric smoothie"));
          this.captions.addCue(new VTTCue(9.5, 11, "Behold Australopithicus!"));
          this.captions.addCue(
            new VTTCue(11.5, 15, "The first man to walk upright.")
          );
          this.captions.addCue(
            new VTTCue(15.5, 17, "Over 4 million years ago,")
          );
          this.captions.addCue(
            new VTTCue(17, 20, "Early man's ability to find nutrition")
          );
          this.captions.addCue(
            new VTTCue(20, 22, "enabled him to grow, evolve")
          );
          this.captions.addCue(
            new VTTCue(22, 25, "and eventually dominate the animal kingdom.")
          );
          this.captions.addCue(
            new VTTCue(25, 29, "But where did this nutrition come from?")
          );
          this.captions.addCue(
            new VTTCue(29, 31, "Notice the oblong indentation")
          );
          this.captions.addCue(
            new VTTCue(31, 34, "on this man's front left incisor.")
          );
          this.captions.addCue(
            new VTTCue(34, 36, "It suggests he used a TOOL")
          );
          this.captions.addCue(new VTTCue(36, 38, "to ingest his food."));
          this.captions.addCue(
            new VTTCue(38, 41, "We think that TOOL was a straw:")
          );
          this.captions.addCue(
            new VTTCue(41, 44, "perfect for sipping bashed bananas")
          );
          this.captions.addCue(
            new VTTCue(44.5, 46, "from a saber-toothed skull.")
          );
          break;
        case 2:
          this.captions.addCue(new VTTCue(0.1, 2, "78 BC"));
          this.captions.addCue(new VTTCue(2, 4, "Nectar of the Gods:"));
          this.captions.addCue(
            new VTTCue(4, 8, "The Smoothie in The Roman Empire")
          );

          this.captions.addCue(
            new VTTCue(8, 10, "Until recently it was thought")
          );
          this.captions.addCue(
            new VTTCue(10, 12, "that this statue of Apollo,")
          );
          this.captions.addCue(new VTTCue(12, 14, "the Roman god of war,"));
          this.captions.addCue(
            new VTTCue(14, 16, "was holding a Gladius short sword.")
          );
          this.captions.addCue(new VTTCue(16, 17, "New evidence suggests"));
          this.captions.addCue(new VTTCue(17, 19, "he was actually holding"));
          this.captions.addCue(
            new VTTCue(19, 21, "a vessel of “blended refreshment”")
          );
          this.captions.addCue(
            new VTTCue(21, 24, "often QUAFFED before a major battle.")
          );

          this.captions.addCue(
            new VTTCue(24, 27, "Being a god, Apollo’s 40oz.")
          );
          this.captions.addCue(
            new VTTCue(27, 31, "beverage container greatly outsized")
          );
          this.captions.addCue(
            new VTTCue(31, 33, "the typical roman cup size of 12oz,")
          );
          this.captions.addCue(
            new VTTCue(33, 34.5, "his large appetite being")
          );
          this.captions.addCue(
            new VTTCue(34.5, 35.5, "another indication of his")
          );
          this.captions.addCue(
            new VTTCue(35.5, 38, "prowess on the battlefield.")
          );

          this.captions.addCue(new VTTCue(38, 40, "By 79 ad,"));
          this.captions.addCue(new VTTCue(40, 41.5, "the emperor Vespasion"));
          this.captions.addCue(
            new VTTCue(41.5, 44, "nearly bankrupted the city of Rome")
          );
          this.captions.addCue(
            new VTTCue(44, 46, "with a feast for Apollo so large")
          );
          this.captions.addCue(new VTTCue(46, 48, "that it took 2000 people"));
          this.captions.addCue(new VTTCue(48, 49.5, "to pick enough berries"));
          this.captions.addCue(
            new VTTCue(49.5, 51, "to fill the massive gold chalice")
          );
          this.captions.addCue(new VTTCue(51, 53, "constructed in his honor."));

          this.captions.addCue(
            new VTTCue(53, 56, "When the drink tipped mid party,")
          );
          this.captions.addCue(
            new VTTCue(56, 58, "no less than 5000 naked guests")
          );
          this.captions.addCue(
            new VTTCue(58, 60, "were washed into the streets")
          );
          this.captions.addCue(new VTTCue(60, 62, "where the party continued"));
          this.captions.addCue(new VTTCue(62, 63, "for 12 more days."));

          break;
        case 3:
          this.captions.addCue(new VTTCue(0.1, 2, "1962"));
          this.captions.addCue(new VTTCue(4.5, 6, "California Dreamin:"));
          this.captions.addCue(
            new VTTCue(6, 9, "How the smoothie got its name")
          );
          this.captions.addCue(new VTTCue(9, 11, "It's been established"));
          this.captions.addCue(
            new VTTCue(11, 13, "that smoothies have been with us")
          );
          this.captions.addCue(new VTTCue(13, 14, "for some time"));
          this.captions.addCue(new VTTCue(14, 15, "but how did"));
          this.captions.addCue(
            new VTTCue(15, 17, "the smoothie get his name?")
          );
          this.captions.addCue(new VTTCue(17, 18, "In California"));
          this.captions.addCue(new VTTCue(18, 20, "in the early 1960’s,"));
          this.captions.addCue(new VTTCue(20, 22, "Surfers and Health Nuts"));
          this.captions.addCue(new VTTCue(22, 24, "were embroiled in a"));
          this.captions.addCue(new VTTCue(24, 25.5, "fierce culture war."));
          this.captions.addCue(new VTTCue(25.5, 27, "Brian Wilson attempted"));
          this.captions.addCue(
            new VTTCue(27, 28.5, "to unite the two factions")
          );
          this.captions.addCue(new VTTCue(28.5, 30, "through music,"));
          this.captions.addCue(
            new VTTCue(30, 32, "but it was a humble surfer")
          );
          this.captions.addCue(new VTTCue(32, 33, "that brought the people"));
          this.captions.addCue(new VTTCue(33, 34, "together with one fun,"));
          this.captions.addCue(new VTTCue(34, 36, "simple word."));
          this.captions.addCue(new VTTCue(36, 38, "The term Smoothie"));
          this.captions.addCue(new VTTCue(38, 39, "traces its origins"));
          this.captions.addCue(new VTTCue(39, 41, "back to a small beach"));
          this.captions.addCue(
            new VTTCue(41, 42.5, "near La Jolla California")
          );
          this.captions.addCue(
            new VTTCue(42.5, 44, "where Bud 'Buddy' Casares")
          );
          this.captions.addCue(
            new VTTCue(44, 46, "talks about how he came up")
          );
          this.captions.addCue(
            new VTTCue(46, 48, "ith the now ubiquitous name")
          );
          this.captions.addCue(
            new VTTCue(49, 51, "Let’s watch this documentary")
          );
          this.captions.addCue(
            new VTTCue(51, 53, "footage of how peace was made.")
          );
          this.captions.addCue(
            new VTTCue(53, 56, "dude from next beach he says")
          );
          this.captions.addCue(new VTTCue(56, 58, "like 'do you want a sip'"));
          this.captions.addCue(new VTTCue(58, 59, "I was real hot,"));
          this.captions.addCue(new VTTCue(59, 60, "surfing all day,"));
          this.captions.addCue(new VTTCue(60, 61, "so i took a sip"));
          this.captions.addCue(new VTTCue(61, 63, "and I was like"));
          this.captions.addCue(new VTTCue(63, 65, "that’s smooooth, man."));

          break;
        case 4:
          this.captions.addCue(new VTTCue(0.1, 3, "1985"));
          this.captions.addCue(new VTTCue(3, 4, "Smoothie Fever"));
          this.captions.addCue(new VTTCue(5.5, 7, "The first appearance"));
          this.captions.addCue(new VTTCue(7, 8, "of a smoothie in a"));
          this.captions.addCue(new VTTCue(8, 10, "video game"));
          this.captions.addCue(new VTTCue(10.5, 12, "By the eighties,"));
          this.captions.addCue(new VTTCue(12, 13, "Smoothies are pouring"));
          this.captions.addCue(new VTTCue(13, 14, "into all facets"));
          this.captions.addCue(new VTTCue(14, 15, "of pop-culture:"));
          this.captions.addCue(new VTTCue(15, 18, "films, music, fashion."));
          this.captions.addCue(new VTTCue(18, 19.5, "The first appearance"));
          this.captions.addCue(new VTTCue(19.5, 21, "of a smoothie in a"));
          this.captions.addCue(
            new VTTCue(21, 23, "video game is thought to be")
          );
          this.captions.addCue(
            new VTTCue(23, 27, "'SUPER DOJO' created by OSC, in 1985.")
          );
          this.captions.addCue(new VTTCue(27, 29.5, "The game is simple."));
          this.captions.addCue(new VTTCue(29.5, 31, "You play as 'Aiko'"));
          this.captions.addCue(new VTTCue(31, 32, "a simple man"));
          this.captions.addCue(new VTTCue(32, 33, "who fights his way"));
          this.captions.addCue(new VTTCue(33, 34, "through a dojo of"));
          this.captions.addCue(
            new VTTCue(34, 36, "increasingly fierce competitors")
          );
          this.captions.addCue(new VTTCue(36, 38, "in search of one goal"));
          this.captions.addCue(new VTTCue(38, 40, "perfection."));
          this.captions.addCue(
            new VTTCue(40, 42, "On the 10th and final level")
          );
          this.captions.addCue(new VTTCue(42, 43, "you face the"));
          this.captions.addCue(new VTTCue(43, 45, "legendary sumo 'Oto'"));
          this.captions.addCue(new VTTCue(45, 48, "and his deadly belly."));
          this.captions.addCue(new VTTCue(48, 49, "The evil Oto"));
          this.captions.addCue(new VTTCue(49, 50, "can only be defeated"));
          this.captions.addCue(new VTTCue(50, 51, "by powering up"));
          this.captions.addCue(new VTTCue(51, 52, "with a Peach smoothie -"));
          this.captions.addCue(
            new VTTCue(53, 55, "releasing your hidden powers.")
          );
          this.captions.addCue(new VTTCue(55, 57, "Why peach?"));
          this.captions.addCue(
            new VTTCue(57, 61, "In Japan, the peach represents truth.")
          );
          this.captions.addCue(
            new VTTCue(61, 64, "Game designer 'Freddie' Murakami")
          );
          this.captions.addCue(new VTTCue(64, 65, "reflected that Aiko"));
          this.captions.addCue(new VTTCue(65, 67, "cares not for fighting,"));
          this.captions.addCue(new VTTCue(67, 68, "although he does not"));
          this.captions.addCue(new VTTCue(68, 69, "yet know it,"));
          this.captions.addCue(new VTTCue(70, 71, "he is simply a man"));
          this.captions.addCue(new VTTCue(71, 73, "trying to get a smoothie."));

          break;
        case 5:
          this.captions.addCue(new VTTCue(0.1, 4, "December 31, 1998"));
          this.captions.addCue(new VTTCue(4, 8, "The Million Dollar Smoothie"));
          this.captions.addCue(new VTTCue(8, 9, "Preserved in a "));
          this.captions.addCue(
            new VTTCue(9, 10, "temperature controlled chamber")
          );
          this.captions.addCue(new VTTCue(10, 12, "for over 2 decades,"));
          this.captions.addCue(new VTTCue(12, 13, "this smoothie"));
          this.captions.addCue(new VTTCue(13, 14, "is thought to be"));
          this.captions.addCue(
            new VTTCue(14, 15, "the most valuable smoothie")
          );
          this.captions.addCue(new VTTCue(15, 16, "on earth"));
          this.captions.addCue(
            new VTTCue(16, 20, "with an estimated value of $1.4 million USD.")
          );
          this.captions.addCue(new VTTCue(20, 23, "On New Years Eve 1998,"));
          this.captions.addCue(new VTTCue(23, 25, "this Raspberry smoothie"));
          this.captions.addCue(new VTTCue(25, 26, "was recovered from"));
          this.captions.addCue(
            new VTTCue(26, 27, "the backstage dressing room")
          );
          this.captions.addCue(new VTTCue(27, 28, "of one the greatest"));
          this.captions.addCue(new VTTCue(28, 30, "performing artists"));
          this.captions.addCue(new VTTCue(30, 32, "of our generation."));
          this.captions.addCue(
            new VTTCue(32, 33, "Known for his genre-bending blend")
          );
          this.captions.addCue(new VTTCue(33, 34, "of funk, dance,"));
          this.captions.addCue(new VTTCue(34, 36, "and rock music,"));
          this.captions.addCue(new VTTCue(36, 37, "the artist also loved"));
          this.captions.addCue(new VTTCue(37, 38, "to blend fruits, yogurt"));
          this.captions.addCue(
            new VTTCue(38, 40, "and nutritional supplements.")
          );
          this.captions.addCue(new VTTCue(40, 42, "When asked about his"));
          this.captions.addCue(new VTTCue(42, 44, "passion for smoothies"));
          this.captions.addCue(new VTTCue(44, 45, "he said"));
          this.captions.addCue(
            new VTTCue(45, 47, "'Funk is the opposite of magic.")
          );
          this.captions.addCue(new VTTCue(47, 49, "It’s about rules."));
          this.captions.addCue(new VTTCue(49, 51, "But smoothies"));
          this.captions.addCue(new VTTCue(51, 52, "truly have no rules."));
          this.captions.addCue(new VTTCue(52, 53, "You can do anything"));
          this.captions.addCue(new VTTCue(53, 55, "with a smoothie."));

          break;
        case 6:
          this.captions.addCue(new VTTCue(0.1, 3, "The future of Smoothies:"));
          this.captions.addCue(
            new VTTCue(3, 7, "The universe’s largest blender")
          );
          this.captions.addCue(new VTTCue(7.5, 9, "Researchers working on"));
          this.captions.addCue(new VTTCue(9, 11, "NASA’s Osirus Rex mission"));
          this.captions.addCue(
            new VTTCue(11, 13, "have made an important discovery")
          );
          this.captions.addCue(
            new VTTCue(13, 16, "- the detection of a black hole")
          );
          this.captions.addCue(
            new VTTCue(16, 18, "just 30,000 light years away.")
          );
          this.captions.addCue(
            new VTTCue(18, 20, "Don't let the name fool you:")
          );
          this.captions.addCue(new VTTCue(20, 22, "a black hole is anything"));
          this.captions.addCue(new VTTCue(22, 24, "but empty space."));
          this.captions.addCue(new VTTCue(24, 25.5, "Rather, it is a great"));
          this.captions.addCue(new VTTCue(25.5, 26.5, "amount of matter"));
          this.captions.addCue(
            new VTTCue(26.5, 29, "packed into a very small area.")
          );
          this.captions.addCue(new VTTCue(29, 30, "think of a star"));
          this.captions.addCue(new VTTCue(30, 31, "a hundred times"));
          this.captions.addCue(new VTTCue(31, 33, "more massive than the Sun"));
          this.captions.addCue(new VTTCue(33, 34, "squeezed into a sphere"));
          this.captions.addCue(
            new VTTCue(34, 36, "the diameter of New York City.")
          );
          this.captions.addCue(new VTTCue(36, 37, "The result is a"));
          this.captions.addCue(
            new VTTCue(37, 40, "gravitational field so strong")
          );
          this.captions.addCue(
            new VTTCue(40, 42, "that everything - even light")
          );
          this.captions.addCue(new VTTCue(42, 43, "gets pulled in and"));
          this.captions.addCue(
            new VTTCue(43, 46, "blended into a single point.")
          );
          this.captions.addCue(
            new VTTCue(46, 47.5, "When we think about blenders")
          );
          this.captions.addCue(new VTTCue(47.5, 49, "here on earth,"));
          this.captions.addCue(new VTTCue(49, 50, "they are nothing compared"));
          this.captions.addCue(new VTTCue(50, 51, "to the blending power"));
          this.captions.addCue(new VTTCue(51, 52, "of a black hole."));
          this.captions.addCue(new VTTCue(53, 54, "says Hans Hjrek at"));
          this.captions.addCue(
            new VTTCue(54, 58, "Stanford University’s Johnson Blend Center.")
          );
          this.captions.addCue(
            new VTTCue(58, 60, "Imagine a drink so blended")
          );
          this.captions.addCue(
            new VTTCue(60, 62, "that the flavors, nutrients,")
          );
          this.captions.addCue(new VTTCue(62, 63, "possibly even"));
          this.captions.addCue(
            new VTTCue(63, 65, "our own thoughts, become one.")
          );
          this.captions.addCue(
            new VTTCue(66, 70, "We’re looking forward to it Hans!")
          );
          break;
        case 7:
          this.captions.addCue(new VTTCue(0.1, 1, "We hope you enjoyed"));
          this.captions.addCue(new VTTCue(1.5, 2, "your visit to"));
          this.captions.addCue(new VTTCue(2, 6, "the Museum of Smoothies."));
          this.captions.addCue(new VTTCue(6, 7, "Our program is"));
          this.captions.addCue(new VTTCue(7, 8, "made possible by our"));
          this.captions.addCue(
            new VTTCue(8, 10, "good friends at Human Improvement")
          );
          this.captions.addCue(new VTTCue(10, 13, "a BETTER way to protein."));
          this.captions.addCue(
            new VTTCue(13, 14, "They’ve generously donated")
          );
          this.captions.addCue(
            new VTTCue(14, 16.5, "a discount in your honor,")
          );
          this.captions.addCue(new VTTCue(16.5, 19, "use code “MUSEUMTOUR”"));
          this.captions.addCue(new VTTCue(19, 22, "for 10% OFF at checkout."));
          this.captions.addCue(new VTTCue(22, 22.6, "Please exit"));
          this.captions.addCue(
            new VTTCue(22.6, 23.5, "through the gift shop,")
          );
          this.captions.addCue(new VTTCue(23.5, 24.5, "and don’t forget"));
          this.captions.addCue(new VTTCue(24.5, 25.5, "to make your way"));
          this.captions.addCue(
            new VTTCue(25.5, 28, "to our recipe hall of fame!")
          );
          break;
        default:
          console.log("No this.captions");
      }
    }

    showBegin() {
      const el = this;
      const active_slide = this.querySelector(
        ".swiper-wrapper .swiper-slide-active"
      );
      this.beginButton.style.transform = "scale(0)";
      this.foundationLogo.style.transform = "scale(0)";
      this.caption.style.transform = "scale(1) translateX(-50%)";
      this.exhibitVid.src = "";
      this.exhibitAudio.src = active_slide.dataset.audio;
      this.exhibitAudio.load();
      this.exhibitAudio.play(0);
      this.audioControl.classList.remove("td-hide");
      this.playing = true;

      anime({
        targets: "#door-left",
        duration: 1230,
        easing: "easeInOutQuad",
        left: -1000,
        delay: 200,
        complete: function () {
          const doors = el.querySelector("#doors");
          if (doors) {
            doors.style = "display: none";
          }
        },
      });

      anime({
        targets: "#door-right",
        duration: 1230,
        easing: "easeInOutQuad",
        right: -1000,
        delay: 200,
      });

      anime({
        targets: "#intro-smoothie",
        duration: 7130,
        easing: "spring(1, 80, 10, 0)",
        scale: [0.3, 1],
        delay: 400,
      });

      anime({
        targets: "#banner",
        duration: 350,
        easing: "spring(1, 80, 10, 0)",
        scale: 0,
        delay: 0,
      });
    }

    showEnds() {
      this.exhibitAudio.pause();
      this.caption.style = "transform: 'scale(0)'";
      this.playing = false;
    }

    removeOldHall(activeIndex) {
      this.playing = true;

      this.querySelectorAll("video").forEach((video) => {
        video.currentTime = 0;
        video.pause();
      });

      this.querySelectorAll("audio").forEach((audio) => {
        audio.currentTime = 0;
        audio.pause();
      });

      this.clearCues();
      this.caption.innerHTML = "";

      const activeSlidePoster = this.slider.querySelector(
        ".swiper-wrapper .swiper-slide-active .poster"
      );
      activeSlidePoster.style.transform = "scale(.5)";
      this.exhibitVid.style.transform = "scale(.5)";
      this.exhibitVid.style.opacity = "0";
      this.foundationLogo.style.transform = "scale(0)";
      this.audioControl.classList.add("td-hide");
      this.spillButton.classList.add("td-hide");

      anime({
        targets: "#exhibit-info",
        duration: 550,
        easing: "easeInOutQuad",
        right: [30, -400],
      });

      anime({
        targets: "#exhibit-date",
        duration: 350,
        easing: "easeInOutQuad",
        top: [50, -100],
        delay: 0,
      });
    }

    setNewHall(activeIndex) {
      this.currentHall = activeIndex;
      const index1 = activeIndex + 1;
      if (activeIndex !== 0 && index1 !== this.totalHalls) {
        this.audioControl.classList.remove("td-hide");
        this.spillButton.classList.remove("td-hide");
        this.caption.transform = "scale(1) translateX(-50%)";
      } else if (activeIndex == 0) {
        this.caption.transform = "scale(1) translateX(-50%)";
        this.foundationLogo.style.transform = "scale(1)";
      } else if ( index1 == this.totalHalls) {
        document.querySelector("#visit-giftshop").classList.remove("td-hide");
      }

      const activeSlidePoster = this.slider.querySelector(
        ".swiper-wrapper .swiper-slide-active .poster"
      );
      activeSlidePoster.style.transform = "scale(1)";
      this.exhibitVid.style.transform = "scale(1)";
      this.exhibitVid.style.opacity = "1";

      //new exhibit info

      const active_slide = this.querySelector(
        ".swiper-wrapper .swiper-slide-active"
      );
      this.querySelector("#exhibit-info").innerHTML =
        active_slide.dataset.title;
      this.querySelector("#exhibit-date").innerHTML = active_slide.dataset.year;

      this.exhibitAudio.muted = this.mute;

      this.exhibitAudio.src = active_slide.dataset.audio;
      this.exhibitAudio.load();
      this.exhibitAudio.play(0);

      this.cues[activeIndex] = document
        .querySelector("#exhibit-audio")
        .addTextTrack("metadata");

      console.log("VIDEO");
      this.exhibitVid.src = active_slide.dataset.vid;
      this.exhibitVid.load();
      this.exhibitVid.play(0);

      this.setCaptions(activeIndex);

      anime({
        targets: "#exhibit-info",
        duration: 550,
        easing: "easeInOutQuad",
        right: [-400, 20],
        delay: 500,
      });

      anime({
        targets: "#exhibit-date",
        duration: 550,
        easing: "easeInOutQuad",
        top: [1000, 30],
      });
    }
  }
  customElements.define("museum-of-smoothies", MuseumOfSmoothies);
}
